import gql from 'graphql-tag'

export const deleteOfferMutation = gql`
  mutation deleteOffer($id: ID!) {
    deleteOffer (id: $id)
  }
`

export const createListMutation = gql`
  mutation createList($list: NewList!) {
    createList(list: $list) {
      id
    }
  }
`

export const createOptionMutation = gql`
  mutation createOption($option: NewOption!) {
    createOption(option: $option) {
      id
    }
  }
`

export const createOptionGroupMutation = gql`
  mutation createOptionGroup($optionGroup: NewOptionGroup!) {
    createOptionGroup(optionGroup: $optionGroup) {
      id
    }
  }
`

export const deleteNodeMutation = gql`
  mutation deleteNode($id: ID!) {
    deleteNode(id: $id) {
      id
    }
  }
`

export const updateListMutation = gql`
  mutation updateList($list: ExistingList!) {
    updateList(list: $list) {
      id
    }
  }
`

export const updateOptionMutation = gql`
  mutation updateOption($option: ExistingOption!) {
    updateOption(option: $option) {
      id
    }
  }
`

export const updateOptionGroupMutation = gql`
  mutation updateOptionGroup($optionGroup: ExistingOptionGroup!) {
    updateOptionGroup(optionGroup: $optionGroup) {
      id
    }
  }
`

export const updateRootMutation = gql`
  mutation updateRoot($root: ExistingRoot!) {
    updateRoot(root: $root) {
      id
    }
  }
`

export const uploadImageMutation = gql`
  mutation uploadImage($file: Upload!) {
    uploadImage(file: $file) {
      path
    }
  }
`

export const deleteUserMutation = gql`
  mutation deleteUser($id: ID!) {
    deleteUser (id: $id)
  }
`




// WEBPACK FOOTER //
// ./src/modules/admin/mutations.js